import React from 'react';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { css } from '@emotion/core';

export const externalLinkActionStyles = css`
  svg {
    width: 13px;
    height: 13px;
  }
`;

interface ExternalLinkActionProps {
  text: string;
  href?: string;
  hideIcon?: boolean;
}

const ExternalLinkAction: React.FC<ExternalLinkActionProps> = ({
  text,
  href = '',
  hideIcon = false,
}) => (
  <a target="_blank" rel="noopener noreferrer" href={href} css={externalLinkActionStyles}>
    {text}
    {!hideIcon && (
      <>
        {' '}
        <ShortcutIcon label="external-link" />
      </>
    )}
  </a>
);

export default ExternalLinkAction;
